module.exports = __webpack_public_path__ + "img/install-ios-01.bbfb98f3.jpg";